import React from 'react'
import * as prismic from '@prismicio/client'
import cms from 'libraries/front-end-core/decorators/cms'
import { useSelector } from 'react-redux'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import NewsTickerDesktop from 'pages/dashboard/NewsTickerDesktop'
import NewsTickerSmallContainer from 'redux/containers/pages/dashboard/NewsTickerSmallContainer'

const NewsTickerTextCms = (props) => {
  const { isLargeDesktop } = useSelector(selectDeviceType)

  return (
    <ResponseConsumer
      response={props.CMS_DATA}
      pendingComponent={() => null}
      content={() => isLargeDesktop
        ? <NewsTickerDesktop {...props} />
        : <NewsTickerSmallContainer {...props} />}
    />
  )
}

const NewsTickerTextCmsWrapper = ({ cmsCtx, aol, ...props }) => {
  const CmsComponent = React.useMemo(() => {
    const queries = {
      predicates: [
        prismic.predicate.at('document.type', 'fc_news_ticker_updates'),
        prismic.predicate.at('my.fc_news_ticker_updates.area_of_law', aol)
      ]
    }

    return cms({ request: (cmsCtx) => cmsCtx.api.get(queries), cacheKey: `fc_news_ticker_updates:${aol}`, cacheTtl: 0 })(NewsTickerTextCms)
  }, [aol])

  if (!cmsCtx) {
    return null
  }

  return <CmsComponent {...{ ...props, aol, cmsCtx }} />
}

export default NewsTickerTextCmsWrapper
